
import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Label } from "@/components/ui/label";
import { StatusSelectionProps } from "@/types/dialog-props";

export const StatusSelectionSection = ({
  status,
  paymentStatus,
  paymentMethodId,
  onStatusChange,
  onPaymentStatusChange,
  onPaymentMethodChange,
  isDisabled = false,
  statusOptions,
  paymentStatusOptions,
  paymentMethodOptions,
  statusLabel = "Статус аренды"
}: StatusSelectionProps) => {
  // Safe fallbacks if options are not provided
  // Default to rental statuses, but can be overridden by statusOptions
  const fallbackStatus = [
    { value: "active", label: "Активный" },
    { value: "pending", label: "К сборке" },
    { value: "ready", label: "К сдаче" },
    { value: "overdue", label: "Просрочен" }
  ];
  const fallbackPaymentStatus = [
    { value: "paid", label: "Оплачено" },
    { value: "partial", label: "Предоплата" },
    { value: "unpaid", label: "Не оплачено" }
  ];
  const fallbackPaymentMethod = [
    { value: "cash", label: "Наличные" },
    { value: "card", label: "Банковская карта" },
    { value: "transfer", label: "Банковский перевод" },
    { value: "online", label: "Онлайн платеж" }
  ];

  const _statusOptions = (statusOptions && statusOptions.length ? statusOptions : fallbackStatus).filter(o => o.value && o.value.trim() !== "");
  const _paymentStatusOptions = (paymentStatusOptions && paymentStatusOptions.length ? paymentStatusOptions : fallbackPaymentStatus).filter(o => o.value && o.value.trim() !== "");
  // Для payment_method НЕ используем fallback значения - только реальные UUID из БД
  // Фильтруем только валидные UUID для предотвращения foreign key constraint errors
  const _paymentMethodOptions = (paymentMethodOptions && paymentMethodOptions.length ? paymentMethodOptions : [])
    .filter(o => o.value && o.value.trim() !== "" && /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(o.value));

  return (
    <div className="bg-muted/50 rounded-lg border p-4">
      <h3 className="text-lg font-medium mb-4">Статус и оплата</h3>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="space-y-2">
          <Label htmlFor="status">{statusLabel}</Label>
          <Select 
            value={status && status.trim() ? status : undefined} 
            onValueChange={onStatusChange}
            disabled={isDisabled}
          >
            <SelectTrigger>
              <SelectValue placeholder="Выберите статус" />
            </SelectTrigger>
            <SelectContent>
              {_statusOptions.map((option) => (
                <SelectItem key={option.value} value={option.value}>
                  {option.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label htmlFor="paymentStatus">Статус оплаты</Label>
          <Select 
            value={paymentStatus && paymentStatus.trim() ? paymentStatus : undefined} 
            onValueChange={onPaymentStatusChange}
            disabled={isDisabled}
          >
            <SelectTrigger>
              <SelectValue placeholder="Статус оплаты" />
            </SelectTrigger>
            <SelectContent>
              {_paymentStatusOptions.map((option) => (
                <SelectItem key={option.value} value={option.value}>
                  {option.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label htmlFor="paymentMethod">Способ оплаты</Label>
          <Select 
            value={paymentMethodId && paymentMethodId.trim() ? paymentMethodId : undefined} 
            onValueChange={onPaymentMethodChange}
            disabled={isDisabled}
          >
            <SelectTrigger>
              <SelectValue placeholder="Способ оплаты" />
            </SelectTrigger>
            <SelectContent>
              {_paymentMethodOptions.map((option) => (
                <SelectItem key={option.value} value={option.value}>
                  {option.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
    </div>
  );
};
